/*
Datetimes off the backend are chrono NaiveDateTime values, so they serialise
without a zone designator — "2026-07-29T18:00:00" — and the instant they name is
UTC.

`new Date()` reads that form as LOCAL time. East of UTC that resolves to an
earlier instant than the backend meant, by the size of the offset, which is
enough to make a freshly minted session look already expired.
 */
const HAS_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/;

/*
Marks a backend datetime as UTC, so it cannot be read as local time. Left alone
if it already carries a zone.

Kept separate from the parse so it can be asserted without depending on the
zone the tests happen to run in: in UTC a local-time misparse lands on the right
instant by coincidence, so no assertion on the parsed Date can catch it there.

@value: the datetime as the backend serialised it.
 */
export function withUtcZone(value: string): string {
    return HAS_ZONE.test(value) ? value : `${value}Z`;
}

/*
Parses a datetime string from the backend into the instant it names.

@value: the datetime as the backend serialised it, with or without a zone.
 */
export function parseBackendDate(value: string): Date {
    return new Date(withUtcZone(value));
}
